export default {
      id: "sunrise-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#sunrise",
      toString: function () {
        return this.url;
      }
    }